export default __webpack_public_path__ + "static/media/icon-payment-methods.89227e91.png";